var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"clnt-summary"},[_c('div',{staticClass:"clnt-summary__heading"},[_c('h2',{staticClass:"clnt-summary__title"},[_vm._v(" Сводка ")]),_c('DatePickerSummary')],1),_c('TableSummary',{attrs:{"summary":_vm.summary}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }